import { initSentryRoot } from "@solvari/common-fe/integrations";
import { localeToIso } from "@solvari/translations";
import { getEnv } from "@solvari/utils";

initSentryRoot({
  addData: () => ({
    tags: {
      domain: window.location.hostname,
      themeId: getEnv().config.themeId,
      locale: localeToIso(getEnv().config.localeCode),
    },
  }),
  project: "expert-sites-fe",
});
